
const headers = {
    method: "GET",
    headers: {
        "Content-type": "application/json;charset=UTF-8",
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjODY1ZjI0YWE2ZDJkMTkyMjQyMDNkOGZmMDIzMWNhNyIsInN1YiI6IjY0MDcxMWNmYWZlMjI0MDBhNDE2MjExNiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.1zCR8HOJzQ4Un1tpN4-iC7w2JpJsT5CiDoDj29bRvW0',
    }
}


export default headers